import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { ErrorHandlerType } from "../types"

const useHttpErrorHandler = (handlers?: ErrorHandlerType) => {
  const navigate = useNavigate()

  const httpErrorHandler = useCallback(
    (error: any) => {
      const httpStatus: number = error.response?.status

      const defaultHandlers: ErrorHandlerType = {
        default: () => {
          toast.error(
            "알 수 없는 오류로 요청을 처리할 수 없습니다. 메인 페이지로 돌아갑니다.",
            {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            }
          )
          navigate("/")
        },
        400: () => {
          toast.error("잘못된 요청입니다.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
        },
        401: () => {
          toast.error("로그인이 필요한 서비스입니다.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
          navigate("/user/login")
        },
        403: () => {
          toast.error("이용 권한이 없는 서비스입니다.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
        },
        404: () => {
          toast.error("요청하신 내용을 찾을 수 없습니다.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
        },
        500: () => {
          toast.error(
            "서버 오류로 요청을 처리할 수 없습니다. 잠시 후 다시 시도해주세요.",
            {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            }
          )
        },
      }

      switch (true) {
        case handlers && Object.keys(handlers).includes(httpStatus.toString()):
          handlers[httpStatus]()
          break
        case Object.keys(defaultHandlers).includes(httpStatus.toString()):
          defaultHandlers[httpStatus]()
          break
        default:
          defaultHandlers.default()
          break
      }
    },
    [handlers, navigate]
  )

  return { httpErrorHandler }
}

export default useHttpErrorHandler
